import React, {Fragment, PureComponent} from "react";
import PropTypes from "prop-types";
import PlacebarMenu from "./components/PlacebarMenu";
import "./style.scss";
import IconButton from "@material-ui/core/IconButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars} from "@fortawesome/free-solid-svg-icons";

export default class Placebar extends PureComponent {
  render() {
    if (!this.props.match.params.facilityId) {
      return null;
    }
    let {facilities, onToggleSidebar} = this.props;
    let facility = this.getFacility();
    let building = this.getBuilding();
    return (
      <Fragment>
        <PlacebarMenu itemLabel="facility" items={Array.from(facilities.values())} selected={facility} />
        <PlacebarMenu
          itemLabel="building"
          items={facility.buildings()}
          selected={building}
          disabled={!facility}
          parent={facility}
        />
        <PlacebarMenu
          itemLabel="floor"
          items={this.getFloors()}
          selected={this.getFloor()}
          parent={building}
          disabled={!building}
        />
        <div className="menuContainer">
          <IconButton className="hamburgerMenu" onClick={onToggleSidebar}>
            <FontAwesomeIcon icon={faBars} />
          </IconButton>
        </div>
      </Fragment>
    );
  }

  getFacility() {
    let {facilities, match} = this.props;
    return facilities.get(match.params.facilityId);
  }

  getBuilding() {
    let {buildingId} = this.props.match.params;
    if (!buildingId) {
      return null;
    }
    return this.getFacility()
      .buildings()
      .find(building => building._id === buildingId);
  }

  getFloors() {
    let building = this.getBuilding();
    return building ? building.floors() : [];
  }

  getFloor() {
    let {floorId} = this.props.match.params;
    if (!floorId) {
      return null;
    }
    let building = this.getBuilding();
    return building.floors().find(floor => floor._id === floorId);
  }
}

Placebar.propTypes = {
  facilities: PropTypes.object,
  match: PropTypes.object.isRequired,
  onToggleSidebar: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Placebar/index.jsx